(function () {
  'use strict';

  // Publish the header's real rendered height as a CSS custom property so
  // other sections (e.g. the homepage hero) can size themselves to exactly
  // "viewport height minus header" without guessing a fixed pixel value.
  function setHeaderHeightVar() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  setHeaderHeightVar();
  window.addEventListener('resize', debounce(setHeaderHeightVar, 150));

  function debounce(fn, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    setHeaderHeightVar();

    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');

    if (!toggle || !nav) return;

    var closeEls = nav.querySelectorAll('[data-menu-close]');
    var lastFocused = null;

    function openMenu() {
      lastFocused = document.activeElement;
      nav.hidden = false;
      document.body.classList.add('nav-open');
      toggle.setAttribute('aria-expanded', 'true');

      var closeButton = nav.querySelector('.mobile-nav__close');
      if (closeButton) closeButton.focus();

      document.addEventListener('keydown', onKeydown);
    }

    function closeMenu() {
      nav.hidden = true;
      document.body.classList.remove('nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);

      if (lastFocused) lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closeMenu();
      }
    }

    toggle.addEventListener('click', function () {
      if (nav.hidden) {
        openMenu();
      } else {
        closeMenu();
      }
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });

    // Mobile accordion submenus (e.g. "Collections" → OG / Originals).
    // Independent of the drawer open/close logic above — a submenu can be
    // expanded/collapsed without affecting the drawer itself.
    var mobileSubmenuToggles = nav.querySelectorAll('[data-mobile-submenu-toggle]');
    mobileSubmenuToggles.forEach(function (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var item = toggleBtn.closest('[data-mobile-submenu-item]');
        var submenu = item && item.querySelector('[data-mobile-submenu]');
        if (!item || !submenu) return;

        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        toggleBtn.setAttribute('aria-expanded', String(!isOpen));
        submenu.hidden = isOpen;
      });
    });
  });

  // Desktop dropdown submenus (e.g. "Collections" → OG / Originals). CSS
  // handles the mouse-hover case; this covers click/tap (touch devices,
  // and anyone who prefers clicking over hovering) and keyboard users
  // pressing Enter/Space on the toggle, plus closing on outside click or
  // Escape. Runs outside DOMContentLoaded's early-return so it still works
  // even if the mobile drawer markup is ever removed from a page.
  document.addEventListener('DOMContentLoaded', function () {
    var submenuItems = document.querySelectorAll('[data-submenu-item]');
    if (!submenuItems.length) return;

    function closeAllSubmenus(except) {
      submenuItems.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var btn = item.querySelector('[data-submenu-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    submenuItems.forEach(function (item) {
      var toggleBtn = item.querySelector('[data-submenu-toggle]');
      if (!toggleBtn) return;

      toggleBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = item.classList.contains('is-open');
        closeAllSubmenus(item);
        item.classList.toggle('is-open', !isOpen);
        toggleBtn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    document.addEventListener('click', function () {
      closeAllSubmenus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllSubmenus();
    });
  });

  // Language selector (desktop header action + mobile nav "list" variant).
  // Both variants share the same root/markup contract, so this handles
  // however many instances exist on the page (normally one of each) with
  // the same logic. Switching language submits Shopify's native
  // `localization` form — no custom navigation/URL building here.
  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-language-selector]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var form = root.querySelector('form');
      var input = root.querySelector('input[name="locale_code"]');
      if (!form || !input) return;

      root.querySelectorAll('[data-language-link]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          input.value = link.getAttribute('data-value');
          form.submit();
        });
      });

      // Only the "dropdown" variant has a toggle/list to open and close —
      // the mobile "list" variant renders its links inline with nothing to
      // disclose, so there's nothing more to wire up for it.
      var toggle = root.querySelector('[data-language-toggle]');
      var list = root.querySelector('[data-language-list]');
      if (!toggle || !list) return;

      function closeList() {
        list.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }

      function openList() {
        list.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        if (list.hidden) {
          openList();
        } else {
          closeList();
        }
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) closeList();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeList();
      });
    });
  });
})();
